import clsx from "clsx";

const PanelHeader = (props) => {
  const { children, sticky = false } = props;

  return <div className={clsx("px-4 py-5 sm:px-6 bg-slate-50", sticky && "sticky top-0")}>{children}</div>;
};

export default PanelHeader;
